// ================== CONVERT TO LAKH ==================
export function convertToLakh(value) {
  if (value == null || isNaN(value)) return 0;

  let num = Number(value);

  // ✅ If already in lakhs (small number), return as is
  if (num < 1000) {
    return num;
  }

  // ✅ If in rupees, convert to lakh
  return num / 100000;
}

// ================== FORMAT LAKH ==================
export function formatLakh(value, withCurrency = true) {
  if (value == null || isNaN(value)) return "-";

  const lakhValue = convertToLakh(value);

  const formatted = lakhValue.toFixed(2).replace(/\.00$/, "");

  return `${withCurrency ? "₹ " : ""}${formatted} L`;
}

// ================== PERCENT ==================
export function formatPercent(value) {
  const num = parseFloat(value);
  if (!Number.isFinite(num)) return "0%";
  return `${num.toFixed(2)}%`;
}
// ================== DECIMAL ==================
export function formatDecimal(value) {
  return Number(value || 0).toFixed(2);
}
// ================== ACHIEVEMENT COLOR ==================
export function getAchievementToneClass(value) {
  if (value == null) return "";

  let numericValue;

  if (typeof value === "string") {
    numericValue = parseFloat(value.replace("%", ""));
  } else {
    // If decimal like 0.55 → convert to %
    numericValue = value <= 1 ? value * 100 : value;
  }

  if (isNaN(numericValue)) return "";

  if (numericValue >= 90) return "positive";   // green
  if (numericValue >= 80) return "warning";    // orange
  return "negative";                           // red
}

export function formatCurrency(value, unit = "lakh") {
  if (value === null || value === undefined) return "—";

  const num = Number(value);

  if (isNaN(num)) return "—";

  switch (unit) {
    case "absolute":
      return `₹ ${num.toLocaleString("en-IN")}`;

    case "lakh":
      return `₹ ${(num / 100000).toFixed(2)} L`;

    case "crore":
      return `₹ ${(num / 10000000).toFixed(2)} Cr`;

    default:
      return num;
  }
}

export function formatNumericUnit(value, unit = "lakh") {
  if (value === null || value === undefined) return "—";

  const num = Number(value);

  if (isNaN(num)) return "—";

  switch (unit) {
    case "absolute":
      return num.toLocaleString("en-IN");

    case "lakh":
      return `${(num / 100000).toFixed(2)} L`;

    case "crore":
      return `${(num / 10000000).toFixed(2)} Cr`;

    default:
      return num;
  }
}

// =========================
// Pill / tone helper classes
// =========================
export function getAchievementPillClass(value) {
  return `coverage-pill ${getAchievementToneClass(value)}`;
}

// =========================
// Rep Visit comparison tone
// =========================
// visit === target   => green
// visit < target    => red
// visit > target    => purple
export function getVisitComparisonToneClass(visit, target, epsilon = 0.000001) {
  const v = Number(visit);
  const t = Number(target);

  if (!Number.isFinite(v) || !Number.isFinite(t)) return "";

  if (Math.abs(v - t) <= epsilon) return "positive"; // green
  if (v < t) return "negative"; // red
  return "purple"; // purple
}

export function getVisitComparisonPillClass(visit, target, epsilon = 0.000001) {
  const tone = getVisitComparisonToneClass(visit, target, epsilon);
  return tone ? `coverage-pill ${tone}` : "";
}

// export function formatPercent(value) {
//   return `${Number(value || 0).toFixed(2)}%`;
// }